import { useSelector } from 'react-redux'
import { GraphValue, Item } from '../../../../../../UI/Chart/DoubleBar/DoubleBar'
import { Concept, ConceptValues } from '../../../../../../../types/Survey/Analysis/Concept'
import props from '../../../../../../../redux/props'
import { ProductionDistance } from '../../../../../../../types/OrganizationUnit'
import DoubleBar from '../../../../../../UI/Chart/DoubleBar/DoubleBar'
import getCombinedUnitsBasedOnSplitType from '../getCombinedUnitsBasedOnSplitType'
type Props = {
  concept: Concept
  productionDistance?: ProductionDistance
  floorUUID?: string
}

const Mitarbeiter: React.FC<Props> = ({ concept, productionDistance, floorUUID }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getUnitValues = (unit: ConceptValues): GraphValue[] => {
    const items = [
      {
        label: t.survey.analysis.calculation.values.mitarbeiter.soll,
        value: unit.originalMitarbeiter,
        stack: 'Soll',
      },
      {
        label: t.survey.analysis.calculation.values.mitarbeiter.ist,
        value: unit.mitarbeiter,
        stack: 'Ist',
      },
    ]

    return items
  }

  const getItems = (): Item[] => {
    const unitList = getCombinedUnitsBasedOnSplitType(concept, productionDistance, floorUUID)

    return unitList.map((unit) => {
      return {
        key: unit.unitUUID,
        label: unit.name,
        values: getUnitValues(unit),
      }
    })
  }

  if (getItems().length === 0) return null
  return <DoubleBar useTransparentColors={false} items={getItems()} suffix={' '} showGrid={true} enableDownload showLegend />
}

export default Mitarbeiter
